import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { Observable } from 'rxjs';
import { CustomDropDownArrowDirective } from 'ok-angular-shared/directives';
import { TextSearchComponent } from 'src/app/shared/components/text-search/text-search.component';
import { AdmOrgTypeaheadComponent } from 'src/app/shared/components/adm-org-typeahead/adm-org-typeahead.component';
import { LocationTypeAheadComponent } from 'src/app/shared/components/location-type-ahead/location-type-ahead.component';
import { AdminSharedDiscountTypeAheadComponent } from 'src/app/shared/components/adm-shared-discount-type-ahead/adm-shared-discount-type-ahead.component';
import { AccessGroupCarType } from 'src/app/shared/enums/access-group-car-type';
import { Organization } from '../../organization/organization-models';
import { ChargingStationLocation } from '../../charging-station-location/charging-station-location-model';
import { IAccessGroupSharedDiscountSearchResultItem } from 'src/app/shared/services/access-group-shared-discount.service';

@Component({
  selector: 'adm-access-group-filter',
  templateUrl: './access-group-filter.component.html',
  styleUrls: ['./access-group-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    ReactiveFormsModule,
    TextSearchComponent,
    AdmOrgTypeaheadComponent,
    LocationTypeAheadComponent,
    AdminSharedDiscountTypeAheadComponent,
    MatFormField,
    MatLabel,
    MatSuffix,
    MatOption,
    MatIcon,
    MatSelect,
    MatButton,
    CustomDropDownArrowDirective,
  ],
})
export class AccessGroupFilterComponent {
  searchText = input<string | null>(null);
  organizationId = input<number | null>(null);
  locationIdentifier = input<string | null>(null);
  selectedCarType = input<AccessGroupCarType | null>(null);
  sharedDiscountIdentifier = input<string | null>(null);
  resetOrgTrigger = input<{ reset: boolean }>({ reset: false });
  resetLocationTrigger = input<{ reset: boolean }>({ reset: false });
  resetDiscountTrigger = input<{ reset: boolean }>({ reset: false });

  search$ = output<Observable<string>>();
  organizationSelected = output<Organization | null>();
  clearOrganizationSelector = output<void>();
  organizationsFetched = output<Organization[] | null>();
  locationSelected = output<ChargingStationLocation | null>();
  discountSelected = output<IAccessGroupSharedDiscountSearchResultItem | null>();
  carTypeSelected = output<AccessGroupCarType | null>();
  resetAllFilters = output<void>();

  protected readonly AccessGroupCarType = AccessGroupCarType;

  onSearchInput(source: Observable<string>) {
    this.search$.emit(source);
  }

  onOrganizationSelected(organization: Organization | null) {
    this.organizationSelected.emit(organization);
  }

  onClearOrganizationSelector() {
    this.clearOrganizationSelector.emit();
  }

  onOrganizationsFetched(organizations: Organization[] | null) {
    this.organizationsFetched.emit(organizations);
  }

  onLocationSelected(location: ChargingStationLocation | null) {
    this.locationSelected.emit(location);
  }

  onDiscountSelected(discount: IAccessGroupSharedDiscountSearchResultItem | null) {
    this.discountSelected.emit(discount);
  }

  onCarTypeSelected(carType: AccessGroupCarType | null) {
    this.carTypeSelected.emit(carType);
  }

  onResetAllFilters() {
    this.resetAllFilters.emit();
  }
}
